var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletSideIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1449 4.79858V1.97986C13.1449 0.885073 12.4007 0 11.4802 0H1.84189C0.921395 0 0.177246 0.885073 0.177246 1.97986V4.79858V6.71802V22.0201C0.177246 23.1149 0.921395 24 1.84189 24H20.3354C21.2559 24 22.0001 23.1149 22.0001 22.0201V6.77844C22.0001 5.68365 21.2559 4.79858 20.3354 4.79858H13.1449ZM1.79111 1.91944H11.528V4.79858H1.79111V1.91944ZM1.79111 22.0806V6.71802H20.3833V22.0806H1.79111Z",
    fill: "#535C64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6971 17.282V11.5201H9.08325V17.2216C9.08325 18.3163 9.8274 19.2014 10.7479 19.2014H21.3007V17.282H10.6971Z",
    fill: "#535C64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1531 15.3604V13.4409H13.9194V15.3604H17.1531Z",
    fill: "#535C64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4262 9.82477L21.1961 11.5203H10.6702L10.9003 9.82477H21.4262Z",
    fill: "#535C64"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletSideIcon);
export default __webpack_public_path__ + "static/media/wallet-side-icon.abe01825650c93c55d877bc8f503c1e2.svg";
export { ForwardRef as ReactComponent };